const hotChips = [
  "反差黑料是谁",
  "事件主角代号",
  "扒皮第一现场",
  "当事人回应口径",
  "身份疑点待证",
  "关系线再更新",
];

const bullets = [
  {
    icon: "ri-question-mark",
    text: "「反差黑料人物」并非单一个体，而是一组围绕同一争议点被反复提及的身份代称。",
  },
  {
    icon: "ri-focus-2-line",
    text: "本期主角：账号运营者「幕布」，正面人设与私下操作的落差是引发扒皮的核心诱因。",
  },
  {
    icon: "ri-user-voice-line",
    text: "至少 3 位当事人先后进入讨论，口径各不相同，身份疑点仍待第三方交叉验证。",
  },
];

export default function Hero() {
  return (
    <section className="relative bg-background-100/80">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          {/* 文案优先区 */}
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 text-primary-700 text-xs font-medium px-3 py-1.5 mb-5">
              <i className="ri-radio-line w-4 h-4 flex items-center justify-center" />
              资讯聚合 · 人物身份追踪专题
            </span>
            <h1 className="text-3xl md:text-5xl font-bold font-heading text-foreground-950 leading-tight tracking-tight">
              反差黑料人物是谁？
              <br />
              一条线索带你看清主角与当事人全貌
            </h1>
            <p className="mt-5 text-sm md:text-base leading-7 text-foreground-600 max-w-xl">
              我们不做定性，只做交叉梳理——把散落在评论区、博主长文与公开资料里的
              <span className="text-primary-700 font-medium">反差黑料扒皮线索</span>
              、<span className="text-primary-700 font-medium">当事人公开信息</span>与
              <span className="text-primary-700 font-medium">身份疑点</span>
              归置到同一张桌上，方便你快速判断「反差黑料是谁」、事件核心人物有哪几位。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row sm:items-center gap-4">
              <a
                href="#personas"
                className="inline-flex items-center justify-center h-11 px-5 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors whitespace-nowrap"
              >
                先看本期人物画像
                <i className="ri-arrow-down-line ml-2 w-4 h-4 flex items-center justify-center" />
              </a>
              <a
                href="#timeline"
                className="inline-flex items-center justify-center h-11 px-5 rounded-md border border-background-300 bg-background-50 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                沿时间线追扒皮过程
              </a>
            </div>
          </div>

          {/* 视觉陪衬 */}
          <div className="lg:col-span-5 flex flex-col gap-4">
            <div className="rounded-xl overflow-hidden border border-background-200 bg-background-50 shadow-sm">
              <div className="h-44 md:h-52 w-full bg-cover bg-top"
                style={{
                  backgroundImage:
                    "url('https://readdy.ai/api/search-image?query=abstract%20editorial%20documentary%20mood%2C%20mysterious%20silhouette%20behind%20frosted%20glass%20with%20magnifying%20glass%20and%20scattered%20press%20clippings%20on%20a%20desk%2C%20warm%20amber%20and%20deep%20crimson%20tonal%20palette%2C%20soft%20window%20light%2C%20layered%20depth%2C%20cinematic%20investigative%20newsroom%20atmosphere%2C%20high%20detail&width=900&height=520&seq=fanca-hero-2026-a1&orientation=landscape')",
                }}
              />
              <div className="p-4 md:p-5">
                <p className="text-xs text-foreground-400 mb-2 inline-flex items-center gap-1.5">
                  <i className="ri-shield-check-line text-accent-600 w-4 h-4 flex items-center justify-center" />
                  本页内容均来自公开渠道的交叉引用，非实名论断
                </p>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 font-heading">
                  今日看点：主角人设「幕布」与背后账号矩阵的落差，是本期最大反差黑料引爆点。
                </h3>
              </div>
            </div>

            <div className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
              <p className="text-xs font-medium text-foreground-400 mb-3 flex items-center gap-1.5">
                <i className="ri-focus-3-line text-primary-600 w-4 h-4 flex items-center justify-center" />
                本期速记 · 3 条
              </p>
              <ul className="space-y-3">
                {bullets.map((b) => (
                  <li key={b.text} className="flex gap-3">
                    <span className="mt-0.5 w-6 h-6 shrink-0 rounded-full bg-accent-100 text-accent-800 flex items-center justify-center">
                      <i className={`${b.icon} text-xs w-3 h-3 flex items-center justify-center`} />
                    </span>
                    <p className="text-xs md:text-sm leading-6 text-foreground-700">{b.text}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* 标签陪衬墙 */}
        <div className="mt-8 md:mt-10 flex flex-wrap items-center gap-2">
          {hotChips.map((c) => (
            <a
              key={c}
              href="#topics"
              className="inline-flex items-center gap-1.5 rounded-full bg-background-50 border border-background-200 px-3 py-1.5 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-price-tag-3-line text-primary-400 w-3.5 h-3.5 flex items-center justify-center" />
              {c}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}